import { render, staticRenderFns } from "./DocumentationView.vue?vue&type=template&id=1f330249&"
import script from "./DocumentationView.ts?vue&type=script&lang=ts&"
export * from "./DocumentationView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports